<script setup>
	import { computed, ref } from 'vue';

	const toggle = ref(false);

	const props = defineProps({
		left: {
			type: [String, Number],
			default: null,
		},
		right: {
			type: [String, Number],
			default: null,
		},
		title: {
			type: String,
			default: null,
		},
		placeholder: {
			type: String,
			default: null,
		},
	});

	const isEmpty = computed(() => {
		return (
			(!props.left || (typeof props.left === 'string' && props.left.trim() === '')) &&
			(!props.right || (typeof props.right === 'string' && props.right.trim() === ''))
		);
	});

	const emit = defineEmits(['toggle']);
</script>

<template>
	<div class="w-full" v-if="!isEmpty">
		<h3 class="text-lg border-b-2 my-2 col-span-2" v-if="title">{{ title }}</h3>
		<div class="w-full flex gap-2 cursor-pointer items-center justify-between">
			<div @click="$emit('toggle', false), (toggle = false)" class="grow">
				<form-input :placeholder="placeholder" :modelValue="left" :class="{ 'opacity-50': toggle, 'pointer-events-none': 'none' }">
				</form-input>
			</div>
			<div class="text-4xl text-green-500">
				<div @click="(toggle = !toggle), $emit('toggle', toggle)">
					<i :class="toggle ? 'fas fa-right-long' : 'fas fa-left-long'"></i>
				</div>
			</div>
			<div @click="$emit('toggle', true), (toggle = true)" class="grow">
				<form-input
					v-if="right"
					:placeholder="placeholder"
					:modelValue="right"
					:class="{ 'opacity-50': !toggle, 'pointer-events-none': 'none' }">
				</form-input>
				<form-input v-else :placeholder="placeholder" :class="{ 'opacity-50': !toggle, 'pointer-events-none': 'none' }"></form-input>
			</div>
		</div>
	</div>
</template>
